export const colors = [
    { name: 'Red', bgClass: 'bg-red-500', feeling: 'Anger' },
    { name: 'Orange', bgClass: 'bg-orange-500', feeling: 'Amusement' },
    { name: 'Yellow', bgClass: 'bg-yellow-500', feeling: 'Joy' },
    { name: 'Green', bgClass: 'bg-green-500', feeling: 'Contentment' },
    { name: 'Blue', bgClass: 'bg-blue-500', feeling: 'Admiration' },
    { name: 'Grey', bgClass: 'bg-gray-500', feeling: 'Sadness' },
    { name: 'Purple', bgClass: 'bg-purple-500', feeling: 'Pride' },
    { name: 'Pink', bgClass: 'bg-pink-500', feeling: 'Love'  },
    { name: 'Teal', bgClass: 'bg-teal-500' ,feeling: 'Compassion' },
  ];



  // research source for ^ map : https://pmc.ncbi.nlm.nih.gov/articles/PMC7027086/